
import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useCalcularPrecios, separadorMillares } from "../../../hooks";
import { TextFormField, ViewPreciosPorRol } from "../../components";
import { buscarProducto } from "../../../helpers/FormulariosCarrito";

import Swal from "sweetalert2";



export const FormularioCantidadx10 = ({ formCarrito, setFormCarrito, funcionAgregar, poducto, 
                                        titulo='Agregar Producto', carrito, medida=6 }) => {



    const { calcularCantidadx10U } = useCalcularPrecios();
    const [ precioReal, setPrecioReal ] = useState(0);



    const handleInputChange = ({ target }) => {
        setFormCarrito({
            ...formCarrito,
            [target.name]: target.value
        });
    }




    useEffect( () => {
        if( poducto ) {
            const  { cliente, distri, empresa, publicista, precioReal } = calcularCantidadx10U( formCarrito.cantidad, poducto);
            setPrecioReal( precioReal - cliente );
            setFormCarrito({
                ...formCarrito,
                totalCliente: cliente,
                totalDistri: distri,
                totalEmpresa: empresa,
                totalPublicista: publicista,
            });
        }
    }, [poducto, formCarrito.cantidad]);




    const handleAgregarAlCarro = (e) => {
        e.preventDefault();
        if( formCarrito.cantidad <= 0 ) {
            return Swal.fire('Error', 'Debes Poner Una Cantidad', 'error');
        }
        if( (formCarrito.cantidad % 10) !== 0 ){
            return Swal.fire('Error', 'La Cantidad debe Ser Multiplos de 10 en 10', 'error');
        }

        const product = buscarProducto(carrito, formCarrito.producto);
        funcionAgregar(product)
    }



    return (


        <form onSubmit={ handleAgregarAlCarro } style={{ width:'100%' }}>
            <Grid container sx={{mt:0}} spacing={2}>
                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label={`Cantidad`}
                        type='number'
                        placeholder="Cantidad"
                        name="cantidad"
                        value={formCarrito.cantidad}
                        onChange={ handleInputChange } 
                    />
                </Grid>

            </Grid>

            {/* Mostrar Precio Segun Rol */}
            <ViewPreciosPorRol formCarrito={formCarrito} />

            <Grid container sx={{ mt:1 }} spacing={2}>
                <Grid item xs={12} sm={(precioReal <= 0) ? 12 : medida}>
                    <Button type="submit" color='primary' variant="contained" fullWidth>{ titulo }</Button>
                </Grid>

                {(precioReal > 0) && (
                <Grid item xs={12} sm={medida}>
                    <Button color='secondary' variant="contained" fullWidth>
                        Ahorra { `$${ separadorMillares( precioReal ) }`}
                    </Button>
                </Grid>
                )}
            </Grid>
        </form> 
        
    )
}
